/* eslint-disable react-hooks/exhaustive-deps */
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLoginSlice } from '../slice';
import { selectIsLoading, selectIsLoggedIn } from '../slice/selectors';
import { ROUTE_PATHS } from '../../../routes/constants';
import { useNavigate } from 'react-router-dom';
import { portalActions } from '../../../layouts/MainLayout/slice';

type LoginFormValues = {
  email: string;
  password: string;
};

const schema = yup.object({
  email: yup.string().email('Enter a valid email').required('Email is required'),
  password: yup.string().min(6, 'At least 6 characters').required('Password is required'),
});
export default function useFormHandler() {
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const { actions } = useLoginSlice();
  const isLoading = useSelector(selectIsLoading);
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const navigate = useNavigate();
  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<LoginFormValues>({
    defaultValues: { email: '', password: '' },
    mode: 'onChange',
    resolver: yupResolver(schema),
  });

  const onSubmit = async (_data: LoginFormValues) => {
    dispatch(actions.login(_data));
  };

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(portalActions.setIsAuthenticated(true));
      navigate(ROUTE_PATHS.PORTAL);
    }
  }, [isLoggedIn]);

  return { control, handleSubmit: handleSubmit(onSubmit), errors, isSubmitting, showPassword, setShowPassword, isLoading };
}
